import { AccordionNav } from './accordion-nav.js';
import ReadMore from './read-more.js';
import { SearchBox } from './search-box.js';
import { SearchPulldown } from './search-pulldown.js';
import { Video } from './video.js';
import sortBy from './sort-by.js';
import responsiveIframe from './responsive-iframe.js';
import googleCalendar from './google-calendar.js';
import newTabLinks from './new-tab-links.js';
import handleFlyoutMenu from './handle-flyout-menu.js';

document.addEventListener('DOMContentLoaded', () => {
  new AccordionNav(document.querySelector('.js-accordion-nav'));

  document.querySelectorAll('.js-search-box').forEach(el => new SearchBox(el));

  // querySelectorAll, not querySelector: the header renders several
  // .js-search-toggle elements (desktop and mobile variants) and the FIRST one is
  // the desktop toggle, which is display:none at mobile widths. Binding only that
  // one left the visible mobile search button wired to nothing.
  document
    .querySelectorAll('.global-top .js-search-toggle')
    .forEach(el => new SearchPulldown(el));

  document.querySelectorAll('.js-c-faqs__answer').forEach(el =>
    ReadMore(el, 'Read More', 'Read Less', '...')
  );

  document.querySelectorAll('.js-c-video__play-button').forEach(el => new Video(el));

  sortBy();
  responsiveIframe();
  googleCalendar();
  newTabLinks('a');

  handleFlyoutMenu('js-primary-nav', 'js-has-submenu', 'primary-nav__submenu', 'primary-nav__submenu-list', 'Home');
  handleFlyoutMenu('js-utility-nav', 'js-utility-item has-submenu', 'global-top__submenu', 'global-top__submenu-group', 'Home');

  // Custom click handler for nav image
  const navImg = document.querySelector('#block-pncb-pncbeenavitem > img');
  const navLink = document.querySelector('#block-pncb-pncbeenavitem > a');
  if (navImg && navLink) navImg.addEventListener('click', () => navLink.click());
});
